import Dict from "../../messages";
import notify from 'devextreme/ui/notify';
import Axios from "../../api/axios";
import React, { useState, useEffect } from 'react';
import { useAuth } from '../../contexts/auth';
import Toolbar, { Item } from 'devextreme-react/toolbar';
import Menu from 'devextreme-react/menu';
import UserPanel from '../user-panel/user-panel';
import './header.scss';
import SelectBox from 'devextreme-react/select-box';
import { navigation } from '../../app-navigation';
import { useHistory } from 'react-router-dom';
import { useTabActions } from '../../contexts/tab-navigation';
import * as glb from "../../globals";
import * as utl from '../../utils/utils.js';
import { loadDevExtremeLocale } from '../../utils/devextremeLocaleLoader';
import BuildStampLabel from '../BuildStampLabel';
// APP_VERSION / BUILD_DATE kaldırıldı — derleme damgası BuildStampLabel ile gösterilir
import { getSelectableUsersWithIncluded } from '../../utils/userLookup';
import { openSsHandoff } from '../../utils/ssHandoff';
import { KULLANICI_LKP_EVENT } from '../../utils/kullaniciLkp';
import CariAtamaBildirimBadge from './CariAtamaBildirimBadge';
import CariIlgiBildirimBadge from './CariIlgiBildirimBadge';
import CariTarihBildirimBadge from './CariTarihBildirimBadge';
import AiWhatsAppBadge from './AiWhatsAppBadge';
import { grantMissingScreenDelete } from '../../utils/ownRecordDelete';
import ApprovalNotificationBadge from './ApprovalNotificationBadge';
import { withHeaderMenuIds } from '../../utils/headerMenuItems';
import { requestBrowserNotificationPermission } from '../../utils/browserBandNotification';

const Header = ({ title }) => {
  const [isSmallScreenState, setIsSmallScreenState] = useState(
    typeof window !== 'undefined' && window.matchMedia('(max-width: 880px)').matches
  );
  const history = useHistory();
  const { openTab, closeAllTabs } = useTabActions();
  const { signOut, user, setActiveUser } = useAuth();
  // State for firma ve kullanıcı combobox'ları - react re-render'ı tetiklemek için
  const [firmaList, setFirmaList] = useState(() => glb.default.FIRMALkp || []);
  const [kullaniziList, setKullaniziList] = useState(() => glb.default.KULLANICILkp || []);
  const dataLoadedRef = React.useRef(false);
  const [openMenuIndex, setOpenMenuIndex] = useState(null);
  
  // isSmallScreen responsive dinle
  React.useEffect(() => {
    const mediaQuery = window.matchMedia('(max-width: 880px)');
    const handleChange = (e) => setIsSmallScreenState(e.matches);
    mediaQuery.addListener(handleChange);
    return () => mediaQuery.removeListener(handleChange);
  }, []);

  React.useEffect(() => {
    requestBrowserNotificationPermission();
  }, []);
  
  // THEME/LANGUAGE STATE HOOKS (must be above mainMenuItems)
  const compactThemeList = React.useMemo(() => ([
    { text: Dict.get('Gündüz'), file: '/themes/dx.light.css' },
    { text: Dict.get('Gündüz(Küçük)'), file: '/themes/dx.light.compact.css' },
    { text: Dict.get('Karmine'), file: '/themes/dx.carmine.css' },
    { text: Dict.get('Karmine(Küçük)'), file: '/themes/dx.carmine.compact.css' },
    { text: Dict.get('Yeşil Sis'), file: '/themes/dx.greenmist.css' },
    { text: Dict.get('Yeşil Sis(Küçük)'), file: '/themes/dx.greenmist.compact.css' },
    { text: Dict.get('Açık Mavi'), file: '/themes/dx.softblue.css' },
    { text: Dict.get('Açık Mavi(Küçük)'), file: '/themes/dx.softblue.compact.css' },
    { text: Dict.get('Mt.Mavi Açık'), file: '/themes/dx.material.blue.light.css' },
    { text: Dict.get('Mt.Mavi Açık(Küçük)'), file: '/themes/dx.material.blue.light.compact.css' },
    { text: Dict.get('Mt.Lime Açık'), file: '/themes/dx.material.lime.light.css' },
    { text: Dict.get('Mt.Lime Açık(Küçük)'), file: '/themes/dx.material.lime.light.compact.css' },
    { text: Dict.get('Mt.Turuncu Açık'), file: '/themes/dx.material.orange.light.css' },
    { text: Dict.get('Mt.Turuncu Açık(Küçük)'), file: '/themes/dx.material.orange.light.compact.css' },
    { text: Dict.get('Mt.Mor Açık'), file: '/themes/dx.material.purple.light.css' },
    { text: Dict.get('Mt.Mor Açık(Küçük)'), file: '/themes/dx.material.purple.light.compact.css' },
    { text: Dict.get('Mt.Teal Açık'), file: '/themes/dx.material.teal.light.css' },
    { text: Dict.get('Mt.Teal Açık(Küçük)'), file: '/themes/dx.material.teal.light.compact.css' },
    { text: Dict.get('Kontrast(Küçük)'), file: '/themes/dx.contrast.compact.css' },
  ]), []);
  const [selectedCompactTheme, setSelectedCompactTheme] = useState(() => {
    try {
      // prefer localStorage override
      const ls = (window.localStorage && window.localStorage.getItem('appCompactTheme')) || null;
      if (ls) return ls;
    } catch (e) { }
    try {
      // önce backend'den gelen kullanıcı objesindeki KUL_TEMA veya eski apptheme
      const tema = glb && glb.default && glb.default.KULLANICI && (glb.default.KULLANICI.KUL_TEMA || glb.default.KULLANICI.apptheme);
      if (tema) {
        let name = ('' + tema).toLowerCase().trim();
        name = name.replace(/^dx\./, '');
        if (name.indexOf('.compact.css') > -1) {
          return name.indexOf('/themes/') === 0 ? name : '/themes/' + name.split('/').pop();
        }
        return '/themes/dx.' + name + '.compact.css';
      }
    } catch (e) { }
    return null;
  });
  const [availableCompactThemes, setAvailableCompactThemes] = useState(compactThemeList);
  const [selectedLanguage, setSelectedLanguage] = useState(
    (glb && glb.default && glb.default.KULLANICI && glb.default.KULLANICI.KUL_DILKOD) ? glb.default.KULLANICI.KUL_DILKOD : 'tr'
  );
  const [selectedCorp, setSelectedCorp] = useState(
    (glb && glb.default && glb.default.KULLANICI && glb.default.KULLANICI.KUL_DEF_FIR_REF) ? glb.default.KULLANICI.KUL_DEF_FIR_REF : null
  );
  const [selectedUserRef, setSelectedUserRef] = useState(
    (glb && glb.default && glb.default.KULLANICI && glb.default.KULLANICI.KUL_REF) ? glb.default.KULLANICI.KUL_REF : null
  );

  // DevExtreme Menu için shortcut ve click fonksiyonları ile menü datası hazırla
  const mainMenuItems = React.useMemo(() => {
    function generateShortcuts(items, used) {
      const getShortcut = (text) => {
        if (!text) return { shortcut: '', index: -1 };
        let i = 0;
        // Do not filter out any characters, support all scripts
        let fallback = null;
        while (i < text.length) {
          const ch = text[i].toUpperCase();
          if (!used.has(ch)) {
            used.add(ch);
            return { shortcut: ch, index: i };
          }
          if (fallback === null) fallback = { shortcut: ch, index: i };
          i++;
        }
        return fallback || { shortcut: text[0].toUpperCase(), index: 0 };
      };
      return items.map(item => {
        const { shortcut, index } = getShortcut(item.text);
        let subItems = item.items;
        if (Array.isArray(subItems) && subItems.length > 0) {
          subItems = generateShortcuts(subItems, used).map(sub => ({
            ...sub,
            onClick: () => (sub.handoffTarget ? openSsHandoff(sub.handoffTarget) : openRouteTab(sub.path, sub.text))
          }));
        }
        return {
          ...item,
          shortcut,
          shortcutIndex: index,
          items: subItems,
          onClick: () => (item.handoffTarget ? openSsHandoff(item.handoffTarget) : openRouteTab(item.path, item.text))
        };
      });
    }

    const openRouteTab = (path, title) => {
      if (!path) return;
      try {
        const mod = require('../../app-routes');
        const list = Array.isArray(mod?.default) ? mod.default : (Array.isArray(mod) ? mod : []);
        const key = String(path).toUpperCase();
        const route = list.find((r) => String(r?.path || '').toUpperCase() === key);
        if (!route?.component) {
          console.warn('[menu] route bulunamadı:', path, 'keys:', list.map((r) => r.path));
          return;
        }
        openTab(path, title, route.component);
        if (history.location.pathname !== '/home') {
          history.push('/home');
        }
      } catch (err) {
        console.error('[menu] openRouteTab', path, err);
      }
    };

    try {
      const items = navigation();
      const used = new Set();
      let result = generateShortcuts(items, used);
      // 'Dil' ve 'Tema' menülerini son ana menünün altına ekle
      if (result.length > 0) {
        const firstMain = result[0];
        const lastMain = result[result.length - 1];

        firstMain.items = [
          ...(firstMain.items || []),
          {
            text: Dict.get('Tüm Ekranları Kapat'),
            onClick: closeAllTabs
          },
          {
            text: Dict.get('Çıkış'),
            onClick: () => {
              signOut();
              if (history) history.push('/login');
            },
            style: { color: '#d32f2f', fontWeight: 700 }
          },
        ];

        lastMain.items = [
          ...(lastMain.items || []),
          {
            text: Dict.get('Dil') + '>',
            items: [
              { text: 'Türkçe', code: 'tr', flag: 'tr.png', onClick: () => handleLanguageChange('tr') },
              { text: 'English', code: 'en', flag: 'en.png', onClick: () => handleLanguageChange('en') },
              { text: 'Deutsch', code: 'de', flag: 'de.png', onClick: () => handleLanguageChange('de') },
              { text: 'Français', code: 'fr', flag: 'fr.png', onClick: () => handleLanguageChange('fr') },
              { text: 'Русский', code: 'ru', flag: 'ru.png', onClick: () => handleLanguageChange('ru') },
              { text: 'العربية', code: 'ar', flag: 'ps.png', onClick: () => handleLanguageChange('ar') },
            ]
          },
          {
            text: Dict.get('Tema') + '>',
            items: (availableCompactThemes || []).map(theme => ({
              text: theme.text,
              file: theme.file,
              onClick: async () => {
                setSelectedCompactTheme(theme.file);
                try { if (window.localStorage) window.localStorage.setItem('appCompactTheme', theme.file || ''); } catch (e) { }
                applyCompactTheme(theme.file);
                // Kullanıcıya backend'de temayı kaydet
                try {
                  if (glb && glb.default && glb.default.KULLANICI && glb.default.KULLANICI.KUL_REF) {
                    await Axios.put(`${process.env.REACT_APP_BACKEND_SERVER}authusr/settheme`, {
                      id: glb.default.KULLANICI.KUL_REF,
                      theme: theme.file
                    });
                    // local KULLANICI objesini de güncelle
                    glb.default.KULLANICI.KUL_TEMA = theme.file;
                    localStorage.setItem('KULLANICI', JSON.stringify(glb.default.KULLANICI));
                  }
                } catch (err) { /* ignore */ }
              }
            }))
          }
        ];
      }
      result.forEach(item => { if (!item.shortcut) item.shortcut = item.text ? item.text[0].toUpperCase() : ''; });
      return withHeaderMenuIds(result);
    } catch (e) {
      return [];
    }
  }, [openTab, history, availableCompactThemes, selectedCorp, firmaList]);

  React.useEffect(() => {
    if (!mainMenuItems || mainMenuItems.length === 0) return;
    const handler = (e) => {
      if (e.ctrlKey && e.altKey && !e.shiftKey && !e.metaKey && !e.repeat) {
        const pressed = e.key.toUpperCase();
        // Ana menüde ara
        let foundIndex = mainMenuItems.findIndex(item => item.shortcut && item.shortcut.length > 0 && item.shortcut.toUpperCase() === pressed);
        if (foundIndex !== -1) {
          // Eğer alt menü varsa submenu'yu açmak için tıklama simüle et
          if (mainMenuItems[foundIndex].items && mainMenuItems[foundIndex].items.length > 0) {
            // DevExtreme Menu'da submenu açmak için ilgili menüye tıklama simüle et
            const menuButtons = document.querySelectorAll('.dx-menu-item');
            if (menuButtons && menuButtons[foundIndex]) {
              menuButtons[foundIndex].dispatchEvent(new MouseEvent('mouseenter', { bubbles: true }));
              menuButtons[foundIndex].focus();
            }
            e.preventDefault();
            return;
          } else if (mainMenuItems[foundIndex].onClick) {
            e.preventDefault();
            mainMenuItems[foundIndex].onClick();
            return;
          }
        }
        // Alt menülerde ara
        let found = null;
        for (const item of mainMenuItems) {
          if (item.items && item.items.length > 0) {
            found = item.items.find(sub => sub.shortcut && sub.shortcut.toUpperCase() === pressed);
            if (found) break;
          }
        }
        if (found && found.onClick) {
          e.preventDefault();
          found.onClick();
        }
      }
    };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [mainMenuItems]);

  // Firma ve Kullanıcı listesi: mount'ta localStorage'dan yükle
  React.useEffect(() => {
    if (dataLoadedRef.current) return;
    try {
      const firmaSaved = localStorage.getItem('FIRMALkp');
      if (firmaSaved) {
        const firmaData = JSON.parse(firmaSaved);
        if (firmaData && firmaData.length > 0) {
          setFirmaList(firmaData);
          glb.default.FIRMALkp = firmaData;
        }
      }
      const kullaniziSaved = localStorage.getItem('KULLANICILkp');
      if (kullaniziSaved) {
        const kullaniziData = JSON.parse(kullaniziSaved);
        if (kullaniziData && kullaniziData.length > 0) {
          setKullaniziList(kullaniziData);
          glb.default.KULLANICILkp = kullaniziData;
        }
      }
      // localStorage boşsa glb'den doldur (login hemen sonrası)
      if (!firmaSaved && glb.default.FIRMALkp && glb.default.FIRMALkp.length > 0) {
        setFirmaList(glb.default.FIRMALkp);
      }
      if (!kullaniziSaved && glb.default.KULLANICILkp && glb.default.KULLANICILkp.length > 0) {
        setKullaniziList(glb.default.KULLANICILkp);
      }
    } catch (e) {
      console.log('Error loading from localStorage:', e);
    }
    dataLoadedRef.current = true;
  }, []);

  React.useEffect(() => {
    const syncKullaniciList = () => {
      const kulp = glb.default.KULLANICILkp || [];
      if (kulp.length > 0) setKullaniziList(kulp);
    };
    window.addEventListener(KULLANICI_LKP_EVENT, syncKullaniciList);
    return () => window.removeEventListener(KULLANICI_LKP_EVENT, syncKullaniciList);
  }, []);

  // Login sonrası user set olduğunda firma/kullanıcı combolarını glb'den senkronize et
  React.useEffect(() => {
    if (!user) return;
    const corp = glb.default.FIRMALkp || [];
    const kulp = glb.default.KULLANICILkp || [];
    if (corp.length > 0) setFirmaList(corp);
    if (kulp.length > 0) setKullaniziList(kulp);
    try {
      const nextUserRef = glb.default?.KULLANICI?.KUL_REF ?? user?.KUL_REF ?? null;
      setSelectedUserRef(nextUserRef);
    } catch (_) { }
  }, [user]);

  const handleUserChange = async (newUserRef) => {
    try {
      if (!newUserRef) return;
      if (Number(newUserRef) === Number(selectedUserRef)) return;
      setSelectedUserRef(newUserRef);

      const userObj = (glb.default.KULLANICILkp || []).find(u => Number(u.KUL_REF) === Number(newUserRef));
      if (!userObj) return;

      let nextUser = userObj;
      try {
        const res = await Axios.get(`${process.env.REACT_APP_BACKEND_SERVER}authusr/me?userid=${userObj.KUL_REF}`);
        if (res.data && res.data.user) {
          nextUser = res.data.user;
          if (res.data.token) localStorage.setItem('jwt_token', res.data.token);
          if (res.data.right) { glb.default.HAKLkp = res.data.right; localStorage.setItem('HAKLkp', JSON.stringify(res.data.right)); }
          if (res.data.screen) {
            const screenRights = grantMissingScreenDelete(res.data.screen);
            glb.default.EKRANLkp = screenRights;
            localStorage.setItem('EKRANLkp', JSON.stringify(screenRights));
          }
          if (res.data.role) { glb.default.ROLLkp = res.data.role; localStorage.setItem('ROLLkp', JSON.stringify(res.data.role)); }
          if (res.data.corp) { glb.default.FIRMALkp = res.data.corp; localStorage.setItem('FIRMALkp', JSON.stringify(res.data.corp)); }
        }
      } catch (_) { /* ignore; fallback to userObj */ }

      glb.default.KULLANICI = nextUser;
      localStorage.setItem('KULLANICI', JSON.stringify(nextUser));
      try { setActiveUser && setActiveUser(nextUser); } catch (_) { }

      // Kullanıcı değişince açık ekranlar kapansın ve ana sayfaya dönsün
      try { closeAllTabs && closeAllTabs(); } catch (_) { }
      try { if (history && history.location && history.location.pathname !== '/home') history.push('/home'); } catch (_) { }
      try { notify(Dict.get('Kullanıcı değiştirildi. Açık ekranlar kapatıldı.'), 'success', 1500); } catch (_) { }
    } catch (e) {
      // keep silent (legacy behavior)
    }
  };

  // Menü başlıklarından çakışmasız, tek harfli shortcut üret
  function generateShortcuts(items, used = new Set()) {
    const getShortcut = (text) => {
      if (!text) return { shortcut: '', index: -1 };
      let i = 0;
      // Do not filter out any characters, support all scripts
      while (i < text.length) {
        const ch = text[i].toUpperCase();
        if (!used.has(ch)) {
          used.add(ch);
          return { shortcut: ch, index: i };
        }
        i++;
      }
      // Hala çakışıyorsa ilk harfi kullan
      return { shortcut: text[0].toUpperCase(), index: 0 };
    };
    return items.map(item => {
      const { shortcut, index } = getShortcut(item.text);
      let subItems = item.items;
      if (Array.isArray(subItems) && subItems.length > 0) {
        subItems = generateShortcuts(subItems, new Set()).map(sub => ({
          ...sub,
          onClick: () => {
            if (!sub.path) return;
            try {
              const mod = require('../../app-routes');
              const list = Array.isArray(mod?.default) ? mod.default : (Array.isArray(mod) ? mod : []);
              const key = String(sub.path).toUpperCase();
              const route = list.find((r) => String(r?.path || '').toUpperCase() === key);
              if (!route?.component) {
                console.warn('[menu] route bulunamadı:', sub.path);
                return;
              }
              openTab(sub.path, sub.text, route.component);
              if (history.location.pathname !== '/home') {
                history.push('/home');
              }
            } catch (err) {
              console.error('[menu] openTab', sub.path, err);
            }
          }
        }));
      }
      return { ...item, shortcut, shortcutIndex: index, items: subItems };
    });
  }





  // Runtime theme validation disabled to prevent browser freeze during hot reload
  // All themes in compactThemeList are assumed to exist
  useEffect(() => {
    setAvailableCompactThemes(compactThemeList);
  }, [compactThemeList]);
  const safeHasRight = (name) => {
    try { return utl.hasRight(name); } catch (e) { return false; }
  };

  const handleLanguageChange = async (newLanguage) => {
    setSelectedLanguage(newLanguage);
    // DevExtreme yerleşik metinlerini yükle ve uygula
    await loadDevExtremeLocale(newLanguage);
    try {
      if (window && window.DevExpress && window.DevExpress.localization) {
        window.DevExpress.localization.locale(newLanguage);
      }
    } catch (e) { }
    // Kullanıcıya kaydet (isteğe bağlı, backend ile entegre)
    try {
      await Axios.put(`${process.env.REACT_APP_BACKEND_SERVER}authusr/setlang`, {
        langcode: newLanguage,
        id: glb.default.KULLANICI.KUL_REF
      });
      glb.default.KULLANICI.KUL_DILKOD = newLanguage;
    } catch (e) { }
  };



  // Simplified compact theme loader - just swap the link href, no DOM removal
  // Cache-aware theme loading with version tracking
  const applyCompactTheme = (file) => {
    try {
      const id = 'dx-compact-theme';
      let link = document.getElementById(id);

      if (!file) {
        if (link) link.parentNode.removeChild(link);
        // Temaya bağlı body sınıfını da temizle
        document.documentElement.classList.remove('app-dark-theme');
        return;
      }

      if (!link) {
        link = document.createElement('link');
        link.rel = 'stylesheet';
        link.id = id;
        link.type = 'text/css';
        // Enable browser caching
        link.crossOrigin = 'anonymous';
        document.head.appendChild(link);
      }

      // Only update href if different (prevents unnecessary reloading)
      if (link.href !== window.location.origin + file) {
        link.href = file;
      }

      // Karanlık tema tespiti ve köke sınıf uygulama
      try {
        const isDark = /\.dark\.|darkmoon|darkviolet|contrast/i.test(file);
        document.documentElement.classList.toggle('app-dark-theme', !!isDark);
      } catch (_) { }
    } catch (e) {
      console.error('Theme application error:', e);
    }
  };

  useEffect(() => {
    // Apply theme only once on mount, not on every selectedCompactTheme change
    try {
      if (selectedCompactTheme) {
        applyCompactTheme(selectedCompactTheme);
      }
    } catch (e) { }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Empty deps - only run on mount








  const handleCorpChange = async (newCorp) => {
    try {
      if (newCorp === selectedCorp) return;
      setSelectedCorp(newCorp);
      // Global aktif firma bilgisini güncelle
      try { if (glb && glb.default) glb.default.cid = newCorp; } catch (_) { }
      try {
        if (glb && glb.default && glb.default.KULLANICI) {
          glb.default.KULLANICI.KUL_DEF_FIR_REF = newCorp;
          // Kalıcılık için localStorage'a yaz
          try { localStorage.setItem('KULLANICI', JSON.stringify(glb.default.KULLANICI)); } catch (_) { }
        }
      } catch (_) { }
      // Açık tüm sekmeleri kapat ve ana sayfaya dön
      try { closeAllTabs && closeAllTabs(); } catch (_) { }
      try { if (history && history.location && history.location.pathname !== '/home') history.push('/home'); } catch (_) { }
      try { notify(Dict.get('Firma değiştirildi. Açık ekranlar kapatıldı.'), 'success', 1500); } catch (_) { }
    } catch (e) { /* ignore */ }
  };


  // eslint-disable-next-line import/no-anonymous-default-export
  // Karanlık tema sınıfını kökten aldığımız için burada ekstra koşula gerek yok,
  // sadece header-component'i render ediyoruz.

  // DevExtreme Menu için click handler
  const handleMenuClick = (e) => {
    if (e.itemData && typeof e.itemData.onClick === 'function') {
      e.itemData.onClick();
    }
  };

  return (
    <header className={'header-component'} role="banner">
      <Toolbar className={'header-toolbar'} stylingMode="text" height={72}>
        <Item location={'before'} locateInMenu={'never'}>
          <div className="app-title header-brand">
            <span className="header-brand-mark">C</span>
            <span className="header-brand-copy"><strong>CRM</strong><small>Yönetim</small></span>
          </div>
        </Item>
        <Item location={'before'} locateInMenu={'never'}>
          <div className="header-navigation">
            <Menu
              className="header-main-menu"
              dataSource={mainMenuItems}
              displayExpr={item => item.text || ''}
              onItemClick={handleMenuClick}
              orientation="horizontal"
              adaptivityEnabled={isSmallScreenState}
              showFirstSubmenuMode={{ name: 'onClick', delay: { show: 0, hide: 100 } }}
              submenuDirection="auto"
              style={{ fontWeight: 700, fontSize: 15, background: 'transparent', border: 'none' }}
              itemRender={item => {
                if (!item.text) return null;
                if (item.flag) {
                  return (
                    <span style={{ display: 'flex', alignItems: 'center', minWidth: 50, maxWidth: 50, fontWeight: 700, margin: '0 12px' }}>
                      <img src={process.env.PUBLIC_URL + '/flags/' + item.flag} alt={item.code} style={{ width: '20px', marginRight: '8px', borderRadius: '2px' }} />
                      <span>{item.text}</span>
                    </span>
                  );
                }
                if (item.text === Dict.get('Tüm Ekranları Kapat') || item.text === Dict.get('Çıkış')) {
                  return (
                    <span style={{ color: '#d32f2f', fontWeight: 700, minWidth: 120, maxWidth: 220, display: 'inline-block', margin: '0 12px' }}>{item.text}</span>
                  );
                }
                const isDilTema = typeof item.text === 'string' && item.text.trim().endsWith('>');
                const isSubMenu = !!item.parentid || !!item.file || !!item.code || isDilTema;
                if (isSubMenu) {
                  const style = {
                    fontWeight: 700,
                    fontStyle: isDilTema ? 'italic' : 'normal',
                    minWidth: 220,
                    maxWidth: 320,
                    display: 'inline-block',
                    textAlign: isDilTema ? 'right' : 'left',
                    margin: '0 12px',
                    whiteSpace: 'normal',
                    overflowWrap: 'anywhere',
                    lineHeight: 1.35,
                  };
                  return (
                    <span style={style}>
                      {item.text.split('').map((ch, i) =>
                        i === item.shortcutIndex && item.shortcut
                          ? <span key={i} style={{ color: '#d32f2f', textDecoration: 'underline', fontWeight: 700 }}>{ch}</span>
                          : ch
                      )}
                    </span>
                  );
                }
                return <span className="header-main-menu-label">{item.text}</span>;
              }}
            />
          </div>
        </Item>
        {isSmallScreenState ? (
          <Item location={'after'} locateInMenu={'always'}>
            <div style={{ minWidth: 200, padding: 8 }}>
              <div style={{ marginBottom: 8 }}><b>{Dict.get('Firma')}</b></div>
              <SelectBox
                dataSource={ (firmaList && firmaList.length > 0 ? firmaList : (glb.default.FIRMALkp || [])) }
                valueExpr={'FIR_REF'}
                displayExpr={item => item && item.FIR_ADI}
                value={selectedCorp}
                onValueChanged={e => handleCorpChange(e.value)}
                placeholder={Dict.get('Firma Seç')}
                width={160}
                showDropDownButton={true}
                searchEnabled={false}
                stylingMode={'filled'}
                dropDownOptions={{ minWidth: 200, wrapperAttr: { class: 'header-account-dropdown' } }}
                showClearButton={false}
              />
              <div style={{ margin: '12px 0 8px 0' }}><b>{Dict.get('Kullanıcı')}</b></div>
              <SelectBox
                dataSource={
                  (() => {
                    const src = (kullaniziList && kullaniziList.length > 0) ? kullaniziList : (glb.default.KULLANICILkp || []);
                    const list = getSelectableUsersWithIncluded(src, [selectedUserRef]);
                    if (glb.default.KULLANICI?.KUL_ISADMIN || glb.default.KULLANICI?.KUL_YETKI === 0) return list;
                    return (glb.default.KULLANICI ? [glb.default.KULLANICI] : list);
                  })()
                }
                valueExpr={'KUL_REF'}
                displayExpr={item => item && (item.KUL_ADI || item.KUL_REF)}
                value={selectedUserRef ?? (glb.default.KULLANICI ? glb.default.KULLANICI.KUL_REF : -1)}
                onValueChanged={e => handleUserChange(e.value)}
                placeholder={Dict.get('Kullanıcı Seç')}
                width={160}
                showDropDownButton={true}
                searchEnabled={false}
                stylingMode={'filled'}
                dropDownOptions={{ minWidth: 200, wrapperAttr: { class: 'header-account-dropdown' } }}
                showClearButton={false}
              />
            </div>
          </Item>
        ) : (
          <Item location={'after'} locateInMenu={'never'}>
            <div className="header-account-fields" style={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                <b style={{ whiteSpace: 'nowrap', fontSize: '12px' }}>{Dict.get('Firma')}</b>
                <SelectBox
                  dataSource={ (firmaList && firmaList.length > 0 ? firmaList : (glb.default.FIRMALkp || [])) }
                  valueExpr={'FIR_REF'}
                  displayExpr={item => item && item.FIR_ADI}
                  value={selectedCorp}
                  onValueChanged={e => handleCorpChange(e.value)}
                  placeholder={Dict.get('Firma Seç')}
                  width={140}
                  showDropDownButton={true}
                  searchEnabled={false}
                  stylingMode={'filled'}
                  dropDownOptions={{ minWidth: 320, wrapperAttr: { class: 'header-account-dropdown' } }}
                  showClearButton={false}
                />
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                <b style={{ whiteSpace: 'nowrap', fontSize: '12px' }}>{Dict.get('Kullanıcı')}</b>
                <SelectBox
                  dataSource={
                    (() => {
                      const src = (kullaniziList && kullaniziList.length > 0) ? kullaniziList : (glb.default.KULLANICILkp || []);
                      const list = getSelectableUsersWithIncluded(src, [selectedUserRef]);
                      if (glb.default.KULLANICI?.KUL_ISADMIN || glb.default.KULLANICI?.KUL_YETKI === 0) return list;
                      return (glb.default.KULLANICI ? [glb.default.KULLANICI] : list);
                    })()
                  }
                  valueExpr={'KUL_REF'}
                  displayExpr={item => item && (item.KUL_ADI || item.KUL_REF)}
                  value={selectedUserRef ?? (glb.default.KULLANICI ? glb.default.KULLANICI.KUL_REF : -1)}
                  onValueChanged={e => handleUserChange(e.value)}
                  placeholder={Dict.get('Kullanıcı Seç')}
                  width={140}
                  showDropDownButton={true}
                  searchEnabled={false}
                  stylingMode={'filled'}
                  dropDownOptions={{ minWidth: 320, wrapperAttr: { class: 'header-account-dropdown' } }}
                  showClearButton={false}
                />
              </div>
            </div>
          </Item>
        )}
        {/* Versiyon Bilgisi */}
        <Item location={'after'} locateInMenu={'never'}>
          <div className="header-session" style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: '4px' }}>
            <BuildStampLabel style={{ marginRight: 0, fontSize: '11px' }} />
            <button type="button" className="header-signout"
              onClick={() => {
                signOut();
                if (history) history.push('/login');
              }}
              title={Dict.get('Çıkış Yap')}
            >
              <span aria-hidden="true">↪</span>
              <span>{Dict.get('Çıkış')}</span>
            </button>
          </div>
        </Item>
      </Toolbar>
      <div className="header-notification-band" role="group" aria-label="Bildirimler">
        <ApprovalNotificationBadge />
        <AiWhatsAppBadge />
        <CariTarihBildirimBadge />
        <CariIlgiBildirimBadge />
        <CariAtamaBildirimBadge />
      </div>
    </header>
  );

}

export default Header;
